import {IMultiOccurrenceOptions} from '../../../../../core/services/multi-occurrence.service';
import {IMenuClass} from '../../../../../core/services/menu/menu.service';
import { IRoute } from '../../../../../core/interfaces/route.interface';

interface IPageRC0009 {
    multiOccurrenceOptions: IMultiOccurrenceOptions;
}
/* @ngInject */
export default function Rc0009Controller(
    Menu: IMenuClass,
    rc0003Route: IRoute
) {
    const vm: IPageRC0009 = this;

    vm.multiOccurrenceOptions = {
        fonctions: {
            rechercheCollapsable: false
        }, 
        actionsNouveaux: new Menu([]),
        navigatePage: rc0003Route.NAME,
        navigateParams: (rowData: any) => {
            return {
                id: rowData.lrtcleint
            };
        },
        colonnesVisibles: [
            {nom: 'ltrcod', largeur: 100},
            {nom: 'lrtcodseq', largeur: 80},
            {nom: 'ltrdsc', largeur: 200},
            {nom: 'tydcod', largeur: 100},
            {nom: 'tyddsc', largeur: 200},
            {nom: 'lrtstu', largeur: 130},
            {nom: 'refcod', largeur: 120},
            {nom: 'refnom', largeur: 200},
            {nom: 'lipcod', largeur: 120},
            {nom: 'lipnom', largeur: 200}
        ],
        colonnesCachees: ['lrtcleint']
    };
}
